const $body = document.querySelector("body");
const $html = document.querySelector("html");

window.theme = window.theme || {};

if (Shopify && typeof Shopify === "object") {
	Shopify.addValueToString = function (str, obj) {
		$.each(obj, function (i) {
			str = str.replace("{{ " + i + " }}", this);
		});

		return str;
	};
	Shopify.handleize = function (str) {
		return str
			.replace(/[-+!"#$€₹%&'* ,./:;<=>?@[\\\]_`{|}~()°^]+/g, "")
			.toLowerCase()
			.replace(/ς/, "σ");
	};
	Shopify.handleizeArray = function (arr) {
		var newArr = [],
			i = 0;

		for (; i < arr.length; i++) {
			newArr[i] = Shopify.handleize(arr[i]);
		}

		return newArr;
	};
	Shopify.formatMoney = function (cents, format) {
		var moneyFormat = "${{amount}}";

		if (typeof cents === "string") {
			cents = cents.replace(".", "");
		}
		var value = "";
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = format || moneyFormat;

		function formatWithDelimiters(number, precision, thousands, decimal) {
			thousands = thousands || ",";
			decimal = decimal || ".";

			if (isNaN(number) || number === null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			var parts = number.split(".");
			var dollarsAmount = parts[0].replace(
				/(\d)(?=(\d\d\d)+(?!\d))/g,
				"$1" + thousands
			);
			var centsAmount = parts[1] ? decimal + parts[1] : "";

			return dollarsAmount + centsAmount;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case "amount":
				value = formatWithDelimiters(cents, 2);
				break;
			case "amount_no_decimals":
				value = formatWithDelimiters(cents, 0);
				break;
			case "amount_with_comma_separator":
				value = formatWithDelimiters(cents, 2, ".", ",");
				break;
			case "amount_no_decimals_with_comma_separator":
				value = formatWithDelimiters(cents, 0, ".", ",");
				break;
			case "amount_no_decimals_with_space_separator":
				value = formatWithDelimiters(cents, 0, " ");
				break;
			case "amount_with_apostrophe_separator":
				value = formatWithDelimiters(cents, 2, "'");
				break;
		}

		return formatString.replace(placeholderRegex, value);
	};
}

// core app
var core = (function () {
	return {
		init: function () {
			core.initDefault();
			core.initResize();
		},
		isHasIOSline: function () {
			const hasHomeIndicator =
				window.safeAreaInsets && window.safeAreaInsets.bottom > 0;
			if (hasHomeIndicator) {
				$body.classList.add("is-iosline");
			}
		},
		isTouchDevice: function () {
			try {
				document.createEvent("TouchEvent");
				return true;
			} catch (e) {
				return false;
			}
		},
		initWebPcheck: function () {
			const canvas = document.createElement("canvas");
			const supportsWebP =
				!!(canvas.getContext && canvas.getContext("2d")) &&
				canvas.toDataURL("image/webp").indexOf("data:image/webp") === 0;
			$body.classList.add(supportsWebP ? "is-webp" : "is-no-webp");
		},
		initResize: function () {},
		initClearHandlers: function () {
			const el = document.querySelector(".js-clear-handlers");
			if (el) {
				el.addEventListener("click", () => {
					core.clearHandlers();
				});
			}
		},
		clearHandlers: function () {
			$body.classList.remove.apply(
				$body.classList,
				Array.from($body.classList).filter((v) => v.startsWith("js-"))
			);
		},
		loader: function (name = "show") {
			const type = name;
			const loader = document.querySelector(".r_loader");
			const createLoader = () => {
				const el = document.createElement("div");
				el.setAttribute("class", "r_loader");
				Array.from({ length: 12 }, () => document.createElement("i")).forEach(
					(newElement) => el.appendChild(newElement)
				);
				$body.appendChild(el);
			};
			switch (type) {
				case "show":
					if (!loader) createLoader();
					$body.classList.add("js-loader-show");
					break;
				case "hide":
					$body.classList.remove("js-loader-show");
					break;
				case "create":
					if (!loader) createLoader();
					break;
			}
		},

		getViewPort: function () {
			const e = window,
				a = "inner";
			if (!("innerWidth" in window)) {
				a = "client";
				e = document.documentElement || document.body;
			}
			return { width: e[a + "Width"], height: e[a + "Height"] };
		},
		/*
		getBreakpoint: function (size) {
			const sizes = {'xs': 0, 'sm': 576, 'md': 768, 'lg': 992, 'xl': 1200, 'xxl': 1400};
			return sizes[size] ?? 0;
		},
		*/
		getEmailFilter: function () {
			return {
				filter:
					/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
			};
		},
		getDeclension: function () {
			const n = Math.abs(n) % 100;
			const n1 = n % 10;
			return n > 10 && n < 20
				? txt[2]
				: n1 > 1 && n1 < 5
				? txt[1]
				: n1 === 1
				? txt[0]
				: txt[2];
		},
		getScrollbarWidth: function () {
			if (!document.querySelector(".r_scrolldetect")) {
				div = document.createElement("div");
				div.className = "r_scrolldetect";
				Object.assign(div.style, {
					width: "100px",
					height: "100px",
					overflow: "scroll",
					position: "absolute",
					top: "-9999px",
				});
				$body.appendChild(div);
			}
			const scrollDiv = document.querySelector(".r_scrolldetect");
			const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
			document.body.removeChild(scrollDiv);
			return scrollbarWidth;
		},
		initFormRestrictRules: function () {
			const uiFormInputRestrict = document.querySelectorAll("*[data-allow]");
			uiFormInputRestrict.length &&
				uiFormInputRestrict.forEach((item) => {
					item.addEventListener("keydown", (e) => {
						const allow = item.dataset.allow;
						const key = e.keyCode;
						const base = [8, 9, 27];
						const numbers = [...Array(10).keys()]
							.map((i) => i + 48)
							.concat([...Array(10).keys()].map((i) => i + 96));
						const spec = [
							189, 187, 219, 221, 220, 186, 222, 191, 110, 111, 106, 109, 107,
							192,
						];
						const isNumericKey = numbers.includes(key);
						const isSpecialKey = spec.includes(key);
						if (allow === "abc" && (isSpecialKey || isNumericKey)) {
							e.preventDefault();
						}
						if (allow === "num") {
							if (
								base.includes(key) ||
								(key === 65 && e.ctrlKey) ||
								(key >= 35 && key <= 40)
							) {
								return;
							}
							if (
								(e.shiftKey || key < 48 || key > 57) &&
								(key < 96 || key > 105)
							) {
								e.preventDefault();
							}
						}
					});
				});
		},
		setScrollbarWidth: function () {
			let scrollWidth = core.getScrollbarWidth();
			$html.setAttribute("style", "--scrollbar-width: " + scrollWidth + "px");
		},
		initDefault: function () {
			$html.classList.remove("no-js"); // check js support
			$body.classList.add(
				core.isTouchDevice() ? "is-touchdevice" : "is-no-touchdevice"
			); // check touchdevice support
			core.initWebPcheck(); // check webp support
			core.isHasIOSline(); // check for ios bottom line
			core.loader("create"); // create loader in DOM
			core.initFormRestrictRules(); // init custom restricts for inputs
			core.initClearHandlers();
			core.setScrollbarWidth();
		},
	};
})();

theme.cart = function () {
	"use strict";

	class CartData {
		constructor() {
			this.rootURL =
				window.langify && window.langify.locale.root_url != "/"
					? window.langify.locale.root_url + "/cart"
					: window.routes.cart_url;
			this.currentData = {};
			this.hasData = false;

			window.addEventListener("storage", (e) => {
				if (e.key === "cartCurrentData") {
					this.setCurrentData(
						JSON.parse(localStorage.getItem("cartCurrentData"))
					);
					this.storageWasModified = true;
				}
			});
		}

		setCurrentData(data) {
			this.currentData = data;
			localStorage.setItem("cartCurrentData", JSON.stringify(this.currentData));
			this.hasData = true;
			return this.currentData;
		}

		updateData(parentResponse) {
			var _ = this;

			return fetch(`${this.rootURL}.js`)
				.then((response) => response.json())
				.then((data) => {
					_.setCurrentData(data);
					return parentResponse;
				})
				.catch((error) => console.error("Error:", error));
		}

		addItem(item) {
			return this.addItems([item]);
		}

		addItems(items) {
			const requestParams = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ items: items }),
			};

			return fetch(`${this.rootURL}/add.js`, requestParams)
				.then((response) => {
					if (response.ok) {
						return this.updateData(response);
					} else {
						return response;
					}
				})
				.catch((error) => console.error("Error:", error));
		}

		changeItemById(id, quantity) {
			const requestParams = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ id: id, quantity: quantity }),
			};

			return fetch(`${this.rootURL}/change.js`, requestParams)
				.then((response) => response.json())
				.then((data) => this.setCurrentData(data))
				.catch((error) => console.error("Error:", error));
		}

		changeItemByLine(line, quantity) {
			const requestParams = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ line: line, quantity: quantity }),
			};

			return fetch(`${this.rootURL}/change.js`, requestParams)
				.then((response) => response.json())
				.then((data) => this.setCurrentData(data))
				.catch((error) => console.error("Error:", error));
		}

		removeItemById(id) {
			return this.changeItemById(id, 0);
		}

		removeItemByLine(line) {
			return this.changeItemByLine(line, 0);
		}
	}

	class CartViewer extends CartData {
		constructor() {
			super();

			this.$counterDesktop = $("[data-js-cart-count-desktop]");
			this.$cartPrice = $("[data-js-cart-price-desktop]");
			this.$counterMobile = $("[data-js-cart-count-mobile]");
			this.$popup = $(".js-popup-cart-ajax");
			this.$freeShipping = $(".js-free-shipping");
		}

		updateCart() {
			this.updateCounter();
			//this.updatePopup();
			//this.updateFreeShipping();
		}

		updateCounter() {
			const count = this.currentData.item_count;
			const price = Shopify.formatMoney(this.currentData.total_price);

			this.$counterDesktop
				.attr("data-js-cart-count-desktop", count)
				.html(count);
			this.$cartPrice.attr("data-js-cart-price-desktop", price).html(price);
			//this.$counterMobile.attr("data-js-cart-count-mobile", count).html(count);
		}
		/*
		updatePopup() {
			if (this.$popup.length) {
				const $content = this.$popup.find(".popup-cart__content"),
					$empty = this.$popup.find(".popup-cart__empty"),
					$items = this.$popup.find(".popup-cart__items"),
					$count = this.$popup.find("[data-js-popup-cart-count]"),
					$subtotal = this.$popup.find("[data-js-popup-cart-subtotal]"),
					$discounts = this.$popup.find("[data-js-popup-cart-discounts]");

				$count.html(
					theme.strings.general.popups.cart.count.replace(
						"{{ count }}",
						this.currentData.item_count
					)
				);
				$content[this.currentData.item_count > 0 ? "removeClass" : "addClass"](
					"d-none-important"
				);
				$empty[this.currentData.item_count > 0 ? "addClass" : "removeClass"](
					"d-none-important"
				);
				$discounts.html("").addClass("d-none");

				if (this.currentData.item_count > 0) {
					const $template = $($("#template-cart-ajax")[0].content),
						$fragment = $(document.createDocumentFragment());

					this.currentData.items.forEach(function (item, i) {
						const $item = $template.clone(),
							$product = $item.find(".product-cart"),
							$image = $item.find(".product-cart__image img"),
							$title = $item.find(".product-cart__title a"),
							$variant = $item.find(".product-cart__variant"),
							$price = $item.find(".product-cart__price .price"),
							$quantity = $item.find(".product-cart__quantity"),
							$remove = $item.find(".product-cart__remove"),
							$links = $item.find("a").not(".product-cart__remove");

						$product.attr("data-product-variant-id", item.variant_id);
						$product.attr("data-product-cart-line", i + 1);
						$links.attr("href", item.url);
						$title.html(item.product_title);
						$image
							.attr("src", Shopify.resizeImage(item.image, "120x"))
							.attr(
								"srcset",
								Shopify.resizeImage(item.image, "120x") +
									" 1x, " +
									Shopify.resizeImage(item.image, "240x") +
									" 2x"
							);
						$quantity.html(item.quantity);
						$remove.attr(
							"href",
							"/cart/change?line=" + (i + 1) + "&amp;quantity=0"
						);

						if (item.variant !== "Default variant") {
							$variant.html(item.variant_title).removeClass("d-none-important");
						}

						theme.ProductCurrency.setPrice($price, item.price);
						$fragment.append($item);
					});

					$items.html("");
					$items.append($fragment);
					theme.ProductCurrency.setPrice(
						$subtotal,
						this.currentData.total_price
					);

					if (this.currentData.cart_level_discount_applications.length) {
						const $template_discount = $(
							$("#template-cart-discount")[0].content
						);

						for (let application of this.currentData
							.cart_level_discount_applications) {
							const $item = $template_discount.clone();

							$item
								.find("[data-js-popup-cart-discount-title]")
								.text(application.title);
							theme.ProductCurrency.setPrice(
								$item.find("[data-js-popup-cart-discount-price]"),
								application.total_allocated_amount
							);
							$discounts.append($item);
						}

						$discounts.removeClass("d-none");
					}

					theme.ProductCurrency.update();
				} else {
					$items.add($subtotal).html("");
				}
			}
		}
			*/
	}

	class CartController extends CartViewer {
		constructor() {
			super();

			this.selectorButtonAdd = ".js-product-button-add-to-cart";
			this.selectorButtonRemove = ".js-product-button-remove-from-cart";

			//this.popupController();
			this.addToCartController();
			this.removeFromCartController();
		}

		set storageWasModified(v) {
			this.updateCart();
		}

		addToCartController() {
			const _ = this;

			$("body").on("click", this.selectorButtonAdd, function (e) {
				const $this = $(this);
				const attrButtonStatus = $this.attr("data-button-status");

				if (attrButtonStatus !== "added" && !$this.hasClass("active")) {
					const $btns = _.mergeWithDuplicateButtons($this);
					core.loader();
					if (attrButtonStatus === "select") {
						const $product = $this.parents("[data-js-product]");

						_.disableButton($btns);
						_.goToProductPage($product);
					} else {
						const $form = $this.parents("form");

						_.disableButton($btns);
						_.addItem(_.serializeForm($form)).then((response) => {
							if (response.ok) {
								_.updateCart();
								_.showPopup();
								_.statusButtonAdded($btns);
								setTimeout(() => _.enableButton($btns), 2000);
								$(".addModal").addClass("add");
							} else if (response.status === 422) {
								return response.json().then((err) => {
									// alert(theme.strings.general.popups.cart.item_added.replace('{{ title }}', title));
									// alert(theme.strings.general.popups.cart.limit_is_exceeded.replace('{{ limit }}', limit));
									alert(err.description);
									_.enableButton($btns);
								});
							}
							core.loader("hide");
						});
					}
				}

				e.preventDefault();
			});
		}

		removeFromCartController() {
			const _ = this;

			$("body").on("click", this.selectorButtonRemove, function (e) {
				const $this = $(this);

				if (!$this.hasClass("active")) {
					const $btns = _.mergeWithDuplicateButtons($this);
					const line = $this
						.parents("[data-js-product]")
						.attr("data-product-cart-line");

					_.disableButton($btns);
					_.removeItemByLine(line).then(() => {
						_.updateCart();
						_.enableButton($btns);
					});
				}

				e.preventDefault();
			});
		}

		mergeWithDuplicateButtons($btn) {
			const cloneId = $btn.attr("data-js-button-add-to-cart-clone-id");

			if (cloneId !== undefined) {
				$btn = $btn.add($(`[data-js-button-add-to-cart-clone="${cloneId}"]`));
			}

			return $btn;
		}

		disableButton($btns) {
			$btns.addClass("active").attr("disabled", "disabled");
		}

		statusButtonAdded($btns) {
			$btns.each(function () {
				const $this = $(this),
					btnWidth = $this.outerWidth();

				$this.css({
					"min-width": `${btnWidth}px`,
				});
			});

			$btns.removeAttr("disabled").attr("data-button-status", "added");
		}

		enableButton($btns) {
			$btns
				.removeAttr("data-button-status disabled style")
				.removeClass("active");
		}

		showPopup() {
			//theme.Popups.callByName("cart");
		}

		goToProductPage($product) {
			location.href = "/products/" + $product.attr("data-product-handle");
		}

		serializeForm($form, serialize_obj = { quantity: 1 }) {
			$form.serializeArray().forEach((obj) => {
				if (["id", "quantity"].includes(obj.name)) {
					serialize_obj[obj.name] = obj.value;
				} else if (obj.name.indexOf("properties") !== -1 && obj.value !== "") {
					serialize_obj.properties = { ...{}, ...serialize_obj.properties };
					serialize_obj.properties[
						obj.name.replace("properties[", "").replace("]", "")
					] = obj.value;
				}
			});
			return serialize_obj;
		}
	}

	theme.cart = new CartController();
};

theme.cart();

$(".js-product-buy").on("click", function (e) {
	e.preventDefault();
	let items = [];
	let base_prod_id = $(this).attr("data-variant");

	items.push({
		id: base_prod_id,
		quantity: 1,
	});

	// let item = {id: base_prod_id, quantity: 1}

	if (items.length === 0) {
		return false;
	}

	theme.cart.addItem({ id: 42738672173195, quantity: 1 });
});

/*
theme.cart = {
	getCart: function () {
		return $.getJSON("/cart.js");
	},

	changeItem: function (key, qty) {
		return this._updateCart({
			type: "POST",
			url: "/cart/change.js",
			data: "quantity=" + qty + "&id=" + key,
			dataType: "json",
		});
	},

	addItemFromForm: function (data) {
		return this._updateCart({
			type: "POST",
			url: "/cart/add.js",
			data: data,
			dataType: "json",
		});
	},

	_updateCart: function (params) {
		return $.ajax(params).then(
			function (cart) {
				return cart;
			}.bind(this)
		);
	},

	updateNote: function (note) {
		var params = {
			type: "POST",
			url: "/cart/update.js",
			data: "note=" + theme.cart.attributeToString(note),
			dataType: "json",
			success: function (cart) {},
			error: function (XMLHttpRequest, textStatus) {},
		};

		$.ajax(params);
	},

	updateCurrency: function (code) {
		var params = {
			type: "POST",
			url: "/cart/update.js",
			data: "currency=" + code,
			dataType: "json",
			success: function (cart) {
				location.reload(); // required for multi-currency feature to update
			},
			error: function (XMLHttpRequest, textStatus) {},
		};

		$.ajax(params);
	},

	attributeToString: function (attribute) {
		if (typeof attribute !== "string") {
			attribute += "";
			if (attribute === "undefined") {
				attribute = "";
			}
		}
		return $.trim(attribute);
	},
};
*/

/*
document.addEventListener(PUB_SUB_EVENTS.cartUpdate, function (event) {
	const cart = event.detail.cart; // Access the cart data
	console.log("Cart updated:", cart);
	updateCartUI(cart); // Call a function to update the UI
});
*/

$(function () {
	$(".js-clear-cart").on("click", function () {
		$.ajax({
			type: "POST",
			url: "/cart/clear.js",
			dataType: "json",
			success: function (response) {},
			error: function (error) {
				console.error("Ошибка при очистке корзины:", error);
			},
		});
	});
});

// wishlistApp
var wishlistApp = (function () {
	return {
		init: function () {
			const wishlistButtons = document.querySelectorAll(".js-wishlist-button");

			wishlistButtons.forEach(function (button) {
				const product = {
					id: button.getAttribute("data-product-id"),
					url: button.getAttribute("data-product-url"),
					vendor: button.getAttribute("data-product-vendor"),
					hit: button.getAttribute("data-product-hit"),
					title: button.getAttribute("data-product-title"),
					description: button.getAttribute("data-product-description"),
					image: button.getAttribute("data-product-image"),
				};

				wishlistApp.updateButtonState(product.id);

				button.addEventListener("click", function (e) {
					e.preventDefault();
					wishlistApp.toggleWishlist(product);
				});
			});
			wishlistApp.updateWishlistCount();
			wishlistApp.displayWishList();
		},
		updateWishlistCount: function () {
			let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
			const wishlistCountElement = document.getElementById("wishlist-count");
			wishlistCountElement.textContent = wishlist.length;
			const toolbarSelector = document.querySelector(".js-wishlist-toolbar");
			if (toolbarSelector) {
				if (wishlist.length > 0) {
					toolbarSelector.querySelector(".icon").innerHTML =
						'<use xlink:href="#addFavorite"></use>';
				} else {
					toolbarSelector.querySelector(".icon").innerHTML =
						'<use xlink:href="#heart"></use>';
				}
			}
		},
		updateButtonState: function (productId) {
			let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
			const buttons = document.querySelectorAll(
				`.js-wishlist-button[data-product-id="${productId}"]`
			);

			buttons.forEach((button) => {
				if (wishlist.some((item) => item.id === productId)) {
					button.classList.add("is-added");
					button.querySelector(".icon").innerHTML =
						'<use xlink:href="#addFavorite"></use>';
					button.setAttribute("title", "Удалить из избранного");
				} else {
					button.classList.remove("is-added");
					button.querySelector(".icon").innerHTML =
						'<use xlink:href="#heart"></use>';
					button.setAttribute("title", "Добавить в избранное");
				}
			});
		},
		toggleWishlist: function (product) {
			let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
			const productIndex = wishlist.findIndex((item) => item.id === product.id);

			if (productIndex !== -1) {
				wishlist.splice(productIndex, 1);
			} else {
				wishlist.push(product);
			}
			localStorage.setItem("wishlist", JSON.stringify(wishlist));

			wishlistApp.updateButtonState(product.id);
			wishlistApp.updateWishlistCount();
		},
		displayWishList: function (a) {
			let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
			const wishlistContainer = document.getElementById("wishlist-items");

			if (wishlistContainer) {
				wishlistContainer.innerHTML = "";
			}

			if (wishlist.length > 0) {
				wishlist.forEach(function (product) {
					let productElement = document.createElement("div");
					productElement.classList.add(
						"cell-3",
						"cell-4-lg",
						"cell-6-sm",
						"cell-12-xs"
					);
					let productHit = "";

					if (product.hit == "true") {
						productHit = `<div class="wrap-cap"><div class="cap"><svg class="icon"><use xlink:href="#logo2"></use></svg><div class="stiker-label">hit</div></div></div>`;
					}

					productElement.innerHTML = `
							 <div class="card cards-col in-collection card-var2" data-product-row="${product.id}">
								  ${productHit}
								  <div class="card-info">
										<div class="card-image">
											 <a href="${product.url}" class="image-inner">
												  <div class="image-wraps">
														<span class="image-container is-square">
															 <span class="image-flex-center">
																  <img loading="lazy" src="${product.image}">
															 </span>
														</span>
												  </div>
											 </a>
										</div>
								  </div>
								  <div class="blue-action">
										<a href="${product.url}" class="show-p">more</a>
										<div class="ns bttn-blue">
											 <span>25.00 NIS</span>
										</div>
										<button type="button" title="Удалить из избранного" class="bttn-favorite remove-from-wishlist" data-product-id="${product.id}">
											 <svg class="icon">
												  <use xlink:href="#addFavorite"></use>
											 </svg>
											 <span class="bttn-favorite-inner is-1"></span>
											 <span class="bttn-favorite-inner is-2"></span>
											 <span class="bttn-favorite-inner is-3"></span>
										</button>
								  </div>
								  <a href="${product.url}" class="link-wrap-var2">
										<p class="title">${product.title}</p>
										<div class="product-short_description">${product.description}</div>
										<div class="stiker-brand">${product.vendor}</div>
								  </a>
							 </div>
						`;
					if (wishlistContainer) {
						wishlistContainer.appendChild(productElement);
					}

					productElement
						.querySelector(".remove-from-wishlist")
						.addEventListener("click", function (e) {
							e.preventDefault();
							wishlistApp.toggleWishlist(product);
							wishlistContainer.removeChild(productElement);
							wishlistApp.displayWishList();
						});
				});
			} else {
				let wishlistMainContainer = document.querySelector(".js-favorite");
				if (wishlistMainContainer) {
					wishlistMainContainer.innerHTML =
						"В списке избранного пока нет добавленных товаров";
				}
			}
		},
	};
})();

// popup app
var smartsetBuy = (function () {
	return {
		init: function () {
			document.querySelectorAll(".multi-add-form").forEach(function (form) {
				form.addEventListener("submit", function (e) {
					e.preventDefault();
					console.log("onsubmit");
					const button = form.querySelector('button[type="submit"]');
					const errors = form.querySelector(".form-errors");
					errors.innerHTML = "";
					const notification = document.querySelector(".cart-notification");
					var items = [];
					button.classList.add("loading");
					button.disabled = true;

					var variantIds = form.querySelectorAll('input[name="variant_id"]');
					var quantities = form.querySelectorAll('input[name="quantity"]');
					var superQuan = Number(form.querySelector("[data-super-quan]").value);

					for (var i = 0; i < variantIds.length; i++) {
						var id = variantIds[i].value;
						var quantity = quantities[i].value;

						items.push({
							id: id,
							quantity: quantity * superQuan,
						});
					}

					var formData = {
						items: items,
					};

					fetch("/cart/add.js", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"X-Requested-With": "XMLHttpRequest",
						},
						body: JSON.stringify(formData),
					})
						.then(function (response) {
							return response.json();
						})
						.then(function (data) {
							button.classList.remove("loading");
							button.disabled = false;
							if (data.status == 422) {
								errors.innerHTML = data.message;
							} else {
								notification.classList.add("active");

								fetch("/cart.js")
									.then((response) => response.json())
									.then((cart) => {
										const cartTarget =
											document.querySelector("#cart-icon-bubble");
										cartTarget.innerHTML = `<svg class="icon">
													<use xlink:href="#basket"></use>
													</svg> 
													<span class="cart-count">${cart.item_count}</span>
													<span class="bar-hover-block">
														<div class="wrap">
															<span class="total">${Shopify.formatMoney(
																cart.total_price,
																"€{{amount_no_decimals}}"
															)}</span>
															<span class="bttn-prim"> Place your order </span>
														</div>
													</span>
													`;
									});
							}
						})
						.catch(function (error) {
							errors.innerHTML = error;
						});
				});
			});
		},
	};
})();

document.addEventListener("DOMContentLoaded", function () {
	wishlistApp.init();
	smartsetBuy.init();
});
